import { motion } from 'framer-motion';

export const ScrollInstruction = () => (
  <div className="flex items-center justify-center gap-2 mt-4">
    <span className="text-sm text-gray-500 dark:text-gray-400">
      Use arrows or scroll horizontally to view more images
    </span>
    <motion.div
      animate={{ x: [0, 10, 0] }}
      transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
    >
      →
    </motion.div>
  </div>
);
